module.exports = __webpack_public_path__ + "static/media/calendar.50d91cbf.svg";